export type AttachmentKind = "image" | "file";

export interface ChatAttachment {
  kind: AttachmentKind;
  url: string;
  name: string;
  mimeType?: string;
  size?: number;
}

export interface ChatReaction {
  emoji: string;
  identity: string;
}

export interface ChatItem {
  id: string;
  name: string;
  text: string;
  time: string;
  mine: boolean;
  attachment?: ChatAttachment;
  reaction?: string;
  pending?: boolean;
}

export interface WhiteboardPoint {
  x: number; // 0-1 normalize
  y: number; // 0-1 normalize
}

export interface WhiteboardStroke {
  color: string;
  width: number;
  points: WhiteboardPoint[];
}

export type CollabKind =
  | "chat"
  | "raise"
  | "lower"
  | "whiteboard-stroke"
  | "whiteboard-clear"
  | "permission"
  | "typing"
  | "reaction"
  | "poll"
  | "poll_vote";

export interface CollabMessage {
  kind: CollabKind;
  name?: string;
  text?: string;
  identity?: string;
  mic?: boolean;
  cam?: boolean;
  stroke?: WhiteboardStroke;
  attachment?: ChatAttachment;
  targetMessageId?: string;
  messageId?: string;
  reaction?: string;
  isTyping?: boolean;
  pollId?: string;
  question?: string;
  options?: string[];
  optionIndex?: number;
}

/** Canlı anket (host oluşturur, öğrenciler oy verir, host canlı sonucu görür). */
export interface Poll {
  id: string;
  question: string;
  options: string[];
  votes: number[];
}

/** Sohbet için kullanılan emoji listesi (kategori bazlı) */
export const EMOJI_CATEGORIES: { label: string; emojis: string[] }[] = [
  {
    label: "Gülenler",
    emojis: ["😀", "😁", "😂", "🤣", "😊", "😇", "🙂", "😉", "😍", "🥰", "😘", "😗", "😋", "😜", "🤪", "🤗", "🤭", "🫢", "🤔", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "😌", "😔", "😪", "😴", "😷", "🥳", "😎", "🤓", "🧐"],
  },
  {
    label: "İfadeler",
    emojis: ["👍", "👎", "👏", "🙌", "👐", "🤝", "🙏", "💪", "✌️", "🤞", "👌", "🤌", "🫶", "🤙", "✊", "👊", "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "💔", "❤️‍🔥", "💖", "💗", "💯", "✨", "🌟", "⭐", "🔥", "💥", "🎉", "🎊"],
  },
  {
    label: "Nesneler",
    emojis: ["📚", "📖", "📝", "✏️", "🖊️", "📐", "📏", "🧮", "🔬", "🧪", "🔭", "💻", "🖥️", "📱", "⌚", "📅", "⏰", "⏳", "🔔", "📌", "📍", "🎯", "🏆", "🥇", "🥈", "🥉", "🎓", "📜", "🏅", "🎖️", "✅", "❌", "❓", "❗", "⚠️", "💡"],
  },
  {
    label: "Doğa & Diğer",
    emojis: ["☀️", "🌙", "🌈", "☁️", "🌧️", "❄️", "🌸", "🌺", "🌻", "🌲", "🍀", "🐱", "🐶", "🦊", "🐼", "🐨", "🦁", "🐢", "🐳", "🦋", "☕", "🍵", "🍎", "🍪", "🎂", "🍰", "🧁", "🍫", "⚽", "🏀", "🎨", "🎵", "🎸", "🎮", "🧩", "🚀"],
  },
];

/** Dosya boyutunu insan okunur formatta gösterir */
export function formatFileSize(bytes?: number): string {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}